import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=7c83f806&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nasa8x/nasa/projects/nodejs/v-quill-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c83f806')) {
      api.createRecord('7c83f806', component.options)
    } else {
      api.reload('7c83f806', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=7c83f806&", function () {
      api.rerender('7c83f806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/editor.vue"
export default component.exports